<template lang="pug">
el-card(@click.native="handleView").campaign-card
  span.campaign_card_title {{ item.campaign_name }}
  hr(style="border:0.5px solid #d8d8d8; margin: 18px 0")
  .campaign-card_normal(v-if="campaignType === 'normal'")
    template(
      v-for="(process, index) in normalCardProcess"
    )
      i(
        :class="['iconfont', process.icon, isActivePhase(index), Object.values(item.progress)[index] === 1 ? 'preparing-phase' : '']"
        style="color: #3370d2; font-size: 26px; position: relative"
      )
      i.iconfont.icon-jiantou(
        v-if="index !== normalCardProcess.length - 1"
        style="font-size: 30px; color: #3370d2"
        :class="isPreparePhase(normalCardProcess[index + 1].id)"
      )

  .campaign_card_lite(v-else)
    template(
      v-for="(process, index) in liteCardProcess"
    )
      i(
        :class="['iconfont', process.icon, isActiveLitePhase(process), isPrepareLitePhase(process)]"
        style="color: #3370d2; font-size: 26px; position: relative"
      )
      i.iconfont.icon-zuobianhenggang-copy(
        v-if="index !== liteCardProcess.length - 1"
        style="font-size: 20px; font-weight:600"
        class="preparing-phase"
      )

</template>

<script>
import axios from 'axios'

export default {
  props: {
    item: {
      type: Object
    },
    campaignType: {
      type: String
    }
  },
  data () {
    return {
      normalCardProcess: [
        {
          id: 1,
          name: 'Request & Brief',
          icon: 'icon-BriefVendor'
        },
        {
          id: 2,
          name: 'Proposal & Quotation',
          icon: 'icon-ProposalQuotation'
        },
        {
          id: 3,
          name: 'Contract & DO',
          icon: 'icon-ContractDO'
        },
        {
          id: 4,
          name: 'Report',
          icon: 'icon-Report'
        }
      ],
      liteCardProcess: [
        {
          name: 'category',
          icon: 'icon-xiangmuleibie'
        },
        {
          name: 'price',
          icon: 'icon-baojia'
        },
        {
          name: 'report',
          icon: 'icon-Report'
        }
      ]
    }
  },
  methods: {
    canViewProcess (id) {
      return axios
        .get('/management/subfinal/canViewProcess', {
          params: {
            campaign_id: id
          }
        })
    },
    getDotProcess (id) {
      return axios.get('/management/subfinal/getDotProcess', {
        params: {
          campaign_id: id
        }
      })
    },
    async handleView () {
      this.$store.commit('campaign/setCampaignVersion', this.item.version)
      this.$store.commit('campaign/setCampaignName', this.item.campaign_name)
      this.$store.commit('campaign/setId', this.item.campaign_id)
      this.$store.commit('campaign/setSubFinalScopeId', this.item.sub_final_scope_id)
      if (this.campaignType === 'normal') {
        this.$store.commit('campaign/setBusinessType', this.item.business_type)
        this.$store.commit('campaign/setPhaseType', this.item.phase_type)
        this.$store.commit('campaign/setOriginalBusinessType', this.item.business_type)
        const [res, dot] = await Promise.all([
          this.canViewProcess(this.item.campaign_id),
          this.getDotProcess(this.item.campaign_id)
        ])
        if (res.can_view) {
          this.$router.push('/campaign/process')
        } else {
          this.$store.commit('campaign/setDotPhaseType', dot.phase_type)
          this.$store.commit('campaign/setDotBusinessType', dot.business_type)
          this.$store.commit('campaign/setDotSubFinalScopeId', dot.sub_final_scope_id)
          this.$router.push('/campaign/dot/social-tracking')
        }
      } else {
        const [res, dot] = await Promise.all([
          this.canViewProcess(this.item.campaign_id),
          this.getDotProcess(this.item.campaign_id)
        ])
        if (res.can_view) {
          this.$store.commit('campaign/setIsNewSubFinalScope', false)
          this.$router.push('/campaign/edit-shortcut')
        } else {
          this.$store.commit('campaign/setDotPhaseType', dot.phase_type)
          this.$store.commit('campaign/setDotBusinessType', dot.business_type)
          this.$store.commit('campaign/setDotSubFinalScopeId', dot.sub_final_scope_id)
          this.$router.push('/shortcut/dot/social-tracking')
        }
      }
    },
    isPreparePhase (id) {
      return id > this.item.phase_type ? 'preparing-phase' : ''
    },
    isActivePhase (index) {
      return Object.values(this.item.progress)[index] === 2 ? 'active-phase' : ''
    },
    isActiveLitePhase (phase) {
      return this.item.progress[phase.name].status === 2 ? 'active-phase' : ''
    },
    isPrepareLitePhase (phase) {
      return this.item.progress[phase.name].status === 1 ? 'preparing-phase' : ''
    }
  }
}
</script>

<style lang="stylus">
.campaign-card
  overflow hidden !important
  cursor pointer
  height 152px
  .campaign_card_header
    display flex
    align-items center
    justify-content flex-end
  .campaign_card_title
    overflow hidden
    line-height 22px
    text-overflow ellipsis
    white-space nowrap
    width 100%
    display block
    font-size 16px
  .campaign-card_normal
    display flex
    justify-content space-around

  .campaign_card_lite
    display flex
    justify-content space-around
    div
      text-align center
      >span
        display block
        font-size 14px
        line-height 20px
        &:nth-child(1)
          position relative
        &:nth-child(2)
          width 60px
          height 3px
          background  $main
          margin-top 15px
          border-radius 30px
      &.disabled
        >span
          &:nth-child(1)
            color #5e5e5e
          &:nth-child(2)
            background #d8d8d8
  .campaign-card__badge
    line-height 13px
    position absolute
    font-size 12px
    border 1px solid $main
    height 12px
    width 12px
    border-radius: 50%
    background $main
    color #ffffff
    text-align center
    right -5px
    top -6px
    span
      transform scale(.5)
      font-size 20px
      display block
  .iconfont.preparing-phase
    color #D8D8D8 !important
  .iconfont.active-phase
    color #66DA9D !important
</style>
